<template>
  <div class="sort-arrow">
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.38287 0.556102L9.04387 4.3291C9.32597 4.6189 9.21747 5.0669 8.78487 5.0669H1.21437C0.783173 5.0669 0.673973 4.6189 0.955373 4.3291L4.61567 0.556102C4.71841 0.456004 4.85618 0.399986 4.99962 0.399986C5.14306 0.399986 5.28083 0.456004 5.38357 0.556102H5.38287Z"
        :fill="upProperties.fill"
        :fill-opacity="upProperties.opacity"
      />
    </svg>
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.78494 0.933105C9.21754 0.933105 9.32604 1.3811 9.04394 1.6709L5.38294 5.4439C5.28023 5.54379 5.14261 5.59968 4.99934 5.59968C4.85607 5.59968 4.71845 5.54379 4.61574 5.4439L0.955442 1.6709C0.674042 1.3811 0.783242 0.933105 1.21444 0.933105H8.78494Z"
        :fill="downProperties.fill"
        :fill-opacity="downProperties.opacity"
      />
    </svg>
  </div>
</template>

<script>
const enabled = { fill: '#364153', opacity: 1 };
const disabled = { fill: 'black', opacity: 0.35 };

export default {
  name: 'Sort',
  props: {
    order: { type: Boolean, default: false },
    enabled: { type: Boolean, default: true },
  },
  computed: {
    upProperties() {
      if (!this.enabled) {
        return disabled;
      }
      return this.order ? enabled : disabled;
    },
    downProperties() {
      if (!this.enabled) {
        return disabled;
      }
      return this.order ? disabled : enabled;
    },
  },
};
</script>
